import { BaseController } from '../../../../../../../common/base/controller';

import template from './qrMismatch.html';

class QrMismatchController extends BaseController {
  constructor(controllerService, qrMismatchService, notificationService) {
    'ngInject';
    super({
      controllerService,
      qrMismatchService,
      notificationService,
    });
  }

  close() {
    this.qrMismatchService.closeModal();
  }

  forceUpload() {
    this.qrMismatchService.forceUpload();
  }

  $onInit() {
    const { expected, found } = this.resolve.data;

    this.expected = {
      customer: expected.customer,
      newIban: expected.newIban,
      oldIban: expected.oldIban,
    };

    this.found = {
      customer: found.customer,
      newIban: found.newIban,
      oldIban: found.oldIban,
    };
  }
}

export default {
  restrict: 'E',
  bindings: {
    resolve: '<',
  },
  template,
  controllerAs: 'vm',
  controller: QrMismatchController,
};
